export enum PrescriptionRenewalStatus {
    Pending,
    New,
    Completed
}
